package ui.component.buttons

import emotion.react.css
import react.FC
import react.Props
import react.ReactNode
import react.Suspense
import react.dom.html.ReactHTML
import ui.styles.Styles
import ui.styles.icons.HandlerSVGProps
import ui.styles.icons.IconsSVG
import web.cssom.px

external interface IconButtonProps : Props {
    var onClick: () -> Unit
    var realIconSVG: IconsSVG?
    var plusMessageLeft: String?
    var plusMessageRight: String?
    var displayElement: Boolean
}

val iconButton = FC<IconButtonProps>{props->

    props.displayElement.takeIf { it != undefined }?.let { dE-> if (!dE) return@FC}

    var t = "_i_"
    var ic = FC<HandlerSVGProps>{  }

    val onCloseOrNone = if (props.onClick == undefined) null else props.onClick

    t = props.realIconSVG?.description?:t
    ic = props.realIconSVG?.iconSVG?:ic

    ReactHTML.button{
        className = Styles.Buttons.iconButton

        title = t

        onClick = {_->
            onCloseOrNone?.invoke()
        }

        if (props.plusMessageLeft != null) {
            ReactHTML.span{
                css {
                    paddingRight = 10.px
                }
                +props.plusMessageLeft
            }
        }

        Suspense{
            this.fallback = ReactNode("__")
            ic()
        }

        if (props.plusMessageRight != null) {
            ReactHTML.span{
                css {
                    paddingLeft = 10.px
                }
                +props.plusMessageRight
            }
        }
    }
}